export const version = 'kunde-v1.20.0-SNAPSHOT-e7f5c5505df0ba77151c86f7386cda37adbeb642';